module.exports = __webpack_public_path__ + "assets/99.jpg?b5f8c29ed4fec75831a980bd8f898e20";